/**
* Tabbed Link Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Link Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-link-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      getTabContentHeight();
      mobileDropdown();
      $( window ).on( 'resize', function() {
        getTabContentHeight();
        mobileDropdown();
      } );
      let tallestContent = 0;
      function getTabContentHeight() {
        tallestContent = 0;
        $( '.tabbed-link-grid_content' ).each( function() {
          if ( $( this ).height() > tallestContent ) {
            tallestContent = $( this ).height();
          }
          $( this ).css( 'position', 'absolute' );
        } );
        setTabContentHeight();
      }

      function setTabContentHeight() {
        $( '.tabbed-link-grid_content-wrapper' ).height( tallestContent+'px' );
      }

      function mobileDropdown() {
        if ( window.innerWidth < 768 ) {
          let open = false;
          $( '.mobile-dropdown' ).on( 'click', function() {
            if ( open === false ) {
              $( this ).addClass( 'is-open' );
              open = true;
            } else if ( open === true ) {
              $( '.mobile-dropdown' ).removeClass( 'is-open' );
              open = false;
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-link-grid', COMPONENT );
} )( app );
